import { render, staticRenderFns } from "./MegaMenuAutomotiveDepartment.vue?vue&type=template&id=db23e772"
import script from "./MegaMenuAutomotiveDepartment.vue?vue&type=script&lang=js"
export * from "./MegaMenuAutomotiveDepartment.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuAutomotiveDepartment.vue?vue&type=style&index=0&id=db23e772&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports